import { danoniKeysConfig } from "./constants"

export function loadDanoniPreset(chartObj, keyKindName) {
  const config = danoniKeysConfig[keyKindName]
  if (!keyKindName) return

  chartObj.setChartParameter("keyKind", keyKindName)
  for (const [k, v] of Object.entries(config.parameters))
    chartObj.setChartParameter(k, v)

  const minColCount = Math.max(config.names.length, config.colours.length)
  if (!isFinite(minColCount)) return
  while (chartObj.columnCount.value < minColCount) {
    chartObj.addChartColumn()
  }

  for (let i = 0; i < minColCount; i++) {
    if (config.names[i])
      chartObj.setColumnParameter(chartObj.orderedCols.value[i].columnId, 'name', config.names[i])
    if (config.colours[i])
      chartObj.setColumnParameter(chartObj.orderedCols.value[i].columnId, 'colour', config.colours[i])
  }
}